import { ThemeUIStyleObject } from "theme-ui";
import { alpha } from "@theme-ui/color";

export const containerStyles: ThemeUIStyleObject = {
  display: "flex",
  flexDirection: "column",
  height: "full",
  width: "full",
  "@media screen and (min-width: 820px)": {
    width: "50%",
  },
  background: "white",
  position: "fixed",
  top: 0,
  right: 0,
  overflow: "hidden",
  zIndex: "navigation",
  color: "darkGray",
  willChange: "transform",
  overflowY: "auto",
};

export const navStyles: ThemeUIStyleObject = {
  pl: [7, 12],
  pr: [7, 12],
  pt: [3, 10],
};

export const listStyles: ThemeUIStyleObject = {
  listStyle: "none",
  marginBottom: 0,
  position: "relative",
  padding: 0,
};

export const itemStyles: ThemeUIStyleObject = {
  display: "block",
  marginBottom: [6, 8],
};

export const linkStyles: ThemeUIStyleObject = {
  display: "block",
  transitionProperty: "color",
  textDecoration: "none",
  fontFamily: "heading",
  fontSize: ["30px", "h2"],
  color: "darkGray",
  transition: "color 200ms ease-in-out",
  "&:hover, &:focus": {
    color: "navHoverGray",
    boxShadow: "none",
  },
  "&.active": {
    color: "navHoverGray",
  },
};

export const languageListStyles: ThemeUIStyleObject = {
  position: "relative",
  display: "flex",
  justifyContent: ["flex-start", "flex-end"],
  pl: [7, 0],
  pb: [9, 13],
  listStyle: "none",
  zIndex: 1,
  flexWrap: "wrap",
};

export const languageItemStyles: ThemeUIStyleObject = {
  pr: 4,
};

export const languageLinkStyles: ThemeUIStyleObject = {
  position: "relative",
  color: alpha("darkGray", 0.3),
  textDecoration: "none",
  pb: 2,
  fontSize: "paragraphSmall",
  letterSpacing: "1px",
  cursor: "pointer",
  transition: "color 200ms ease-in-out",
  ":after": {
    transition: "background-color 200ms ease-in-out",
    content: "''",
    width: "full",
    height: "1px",
    position: "absolute",
    bottom: 0,
    left: 0,
    bg: "transparent",
  },
  ":hover, :focus, :active": {
    color: "darkGray",
    ":after": {
      bg: "darkGray",
    },
  },
};

export const languageLinkActiveStyles: ThemeUIStyleObject = {
  position: "relative",
  color: "darkGray",
  pb: 2,
  fontSize: "paragraphSmall",
  cursor: "pointer",
  ":after": {
    content: "''",
    width: "full",
    height: "1px",
    position: "absolute",
    bottom: 0,
    left: 0,
    bg: "darkGray",
  },
};
